import {
  FilterType,
  buildTrainingMembershipsDataTableFilter,
  useTrainingMembershipsDataTable,
} from 'generated/resources/datatable.graphql'
import { TrainingsTrainingMembershipStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { TrainingStatusTag } from './TrainingStatusTag'

type FilterOption = {
  label: string
  value: TrainingsTrainingMembershipStatusEnum
  component: JSX.Element
}

export const trainingStatusFilter = (
  source: ReturnType<typeof useTrainingMembershipsDataTable>
) => {
  const options: FilterOption[] = [
    {
      label: i18n.t('trainings.my_training.all_courses_table.not_assigned'),
      value: 'notassigned',
      component: <TrainingStatusTag status="notassigned" />,
    },
    {
      label: i18n.t('trainings.my_training.all_courses_table.not_started'),
      value: 'notstarted',
      component: <TrainingStatusTag status="notstarted" />,
    },
    {
      label: i18n.t('trainings.my_training.all_courses_table.completed'),
      value: 'completed',
      component: <TrainingStatusTag status="completed" />,
    },
    {
      label: i18n.t('trainings.my_training.all_courses_table.started'),
      value: 'started',
      component: <TrainingStatusTag status="started" />,
    },
    {
      label: i18n.t('trainings.my_training.all_courses_table.partially_completed'),
      value: 'partiallycompleted',
      component: <TrainingStatusTag status="partiallycompleted" />,
    },
    {
      label: i18n.t('trainings.my_training.all_courses_table.absent'),
      value: 'missing',
      component: <TrainingStatusTag status="missing" />,
    },
  ]
  return buildTrainingMembershipsDataTableFilter(source, {
    identifier: 'status_filter',
    title: i18n.t('trainings.trainings_revamp.training_employee_table.filters.status'),
    path: 'status',
    default: true,
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
        hideSearch: true,
      },
    ],
  })
}
